module.exports = __webpack_public_path__ + "static/GetDown-e1b29695da7a747e3f9a1cd7b62eb35a.gif";